import React from "react";
import { Box, Container, Grid, Typography, Button, Stack } from "@mui/material";
import { motion } from "framer-motion";

const IntroHydroluz = () => {
  const productsUrl = "/categorias";
  const whatsappUrl =
    "https://wa.me/593991911882?text=" +
    encodeURIComponent("Hola HYDROLUZ, quiero información sobre sus productos.");

  return (
    <Box className="intro-slide">
      <Container maxWidth="lg" className="intro-slide-container">
        <Grid container alignItems="center" className="intro-slide-grid">
          <Grid item xs={12} md={6} className="intro-slide-left">
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Typography
                component="h1"
                variant="unstyled"
                className="intro-slide-title"
              >
                HYDROLUZ es tu tienda <span>100% en línea</span>.
              </Typography>

              <Typography className="intro-slide-text">
                Compra fácil, recibe rápido y encuentra productos para tu hogar y obra en un solo lugar.
              </Typography>

              <Stack direction={{ xs: "row", sm: "row" }} spacing={1.2} className="intro-slide-actions">
                <Button href={productsUrl} variant="contained" className="intro-btn intro-btn-primary">
                  Ver productos
                </Button>

                <Button
                  href={whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  variant="outlined"
                  className="intro-btn intro-btn-secondary"
                >
                  Escríbenos
                </Button>
              </Stack>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6} className="intro-slide-right">
            <motion.div
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="intro-slide-image-wrap"
            >
              <img
                src={require("../../static/media/home/shop.webp")}
                alt="HYDROLUZ tienda online"
                className="intro-slide-image"
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default IntroHydroluz;